// src/pages/dashboard/Consumption.js
import React, { useEffect, useState } from "react";
import { fetchConsumptionData } from "../../api/project/projectApi";
import { FaCircleChevronLeft, FaCircleChevronRight } from "react-icons/fa6";

const Consumption = () => {
  const [assessments, setAssessments] = useState([]);
  const user_id = localStorage.getItem("user_id");

  useEffect(() => {
    const fetchConsumptionDatas = async () => {
      try {
        if (!user_id) return;
        const response = await fetchConsumptionData(user_id);
        setAssessments(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchConsumptionDatas();
  }, [user_id]);

  const currentDate = new Date();
  const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth());
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());

  const availableYears = [];
  for (let year = 2024; year <= currentDate.getFullYear(); year++) {
    availableYears.push(year);
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handlePrevMonth = () => {
    if (selectedYear > 2024 || selectedMonth > 0) {
      if (selectedMonth === 0) {
        setSelectedMonth(11);
        setSelectedYear((prev) => prev - 1);
      } else {
        setSelectedMonth((prev) => prev - 1);
      }
    }
  };

  const handleNextMonth = () => {
    if (
      selectedYear < currentDate.getFullYear() ||
      (selectedYear === currentDate.getFullYear() &&
        selectedMonth < currentDate.getMonth())
    ) {
      if (selectedMonth === 11) {
        setSelectedMonth(0);
        setSelectedYear((prev) => prev + 1);
      } else {
        setSelectedMonth((prev) => prev + 1);
      }
    }
  };

  const filteredAssessments = assessments.filter((assessment) => {
    const date = new Date(assessment.created_at);
    return (
      date.getMonth() === selectedMonth && date.getFullYear() === selectedYear
    );
  });

  const totalMonthlyCost = filteredAssessments.length * 10;

 return (
  <div className="w-full min-h-screen relative overflow-hidden bg-white p-6">
    {/* <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
    <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div> */}

    
    <div className="relative z-10 w-11/12 mx-auto">

     
      <div className="flex items-center justify-between mb-8 p-4 bg-transparent backdrop-blur-md rounded-xl ">
        <h2 className="text-2xl md:text-3xl font-bold bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
          Consumption Statistics
        </h2>
      </div>

     
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-8 p-5 bg-transparent backdrop-blur-md rounded-xl shadow-md ">

       
        <div className="flex items-center gap-4 bg-white shadow-sm px-4 py-2 rounded-lg">

          <button
            onClick={handlePrevMonth}
            className={`p-2 rounded-full transition ${
              selectedYear === 2024 && selectedMonth === 0
                ? "text-gray-300 cursor-not-allowed"
                : "hover:bg-purple-100 text-purple-600"
            }`}
            disabled={selectedYear === 2024 && selectedMonth === 0}
          >
            <FaCircleChevronLeft className="text-lg" />
          </button>

          <h3 className="text-lg font-semibold text-gray-700 min-w-[160px] text-center">
            {months[selectedMonth]} {selectedYear}
          </h3>

          <button
            onClick={handleNextMonth}
            className={`p-2 rounded-full transition ${
              selectedYear === currentDate.getFullYear() &&
              selectedMonth === currentDate.getMonth()
                ? "text-gray-300 cursor-not-allowed"
                : "hover:bg-blue-100 text-blue-600"
            }`}
            disabled={
              selectedYear === currentDate.getFullYear() &&
              selectedMonth === currentDate.getMonth()
            }
          >
            <FaCircleChevronRight className="text-lg" />
          </button>
        </div>

        
        <div className="w-full md:w-[180px]">
          <select
            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none bg-white shadow-sm"
            value={selectedYear}
            onChange={(e) => setSelectedYear(parseInt(e.target.value))}
          >
            {availableYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>


      <div className="bg-white/80 backdrop-blur-md rounded-2xl shadow-xl border overflow-hidden">

        
        <table className="w-full text-sm">

          
          <thead>
            <tr className="bg-gradient-to-l from-indigo-950 to-indigo-800 text-white">
              <th className="p-4 text-left">Code</th>
              <th className="p-4 text-left">Project Name</th>
              <th className="p-4 text-left">Participant</th>
              <th className="p-4 text-center">Date</th>
              <th className="p-4 text-center">Amount</th>
            </tr>
          </thead>

          
          <tbody className="divide-y">
            {filteredAssessments.length > 0 ? (
              filteredAssessments.map((assessment, index) => (
                <tr
                  key={index}
                  className="hover:bg-purple-50 transition duration-200"
                >
                  <td className="p-4 font-medium text-gray-700">
                    {assessment.question_code}
                  </td>
                  <td className="p-4 font-semibold text-gray-900">
                    {assessment.project_name}
                  </td>
                  <td className="p-4 text-gray-600">
                    {assessment.learner}
                  </td>
                  <td className="p-4 text-center text-gray-500">
                    {new Date(assessment.created_at).toLocaleDateString()}
                  </td>
                  <td className="p-4 text-center font-semibold text-green-600">
                    ₹10
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center p-8 text-gray-400">
                  No assessments found for this month.
                </td>
              </tr>
            )}
          </tbody>

        
          <tfoot>
            <tr className="bg-gradient-to-r from-green-100 to-green-200 text-green-800">
              <td colSpan="4" className="p-4 font-bold text-left">
                Total Monthly Cost
              </td>
              <td className="p-4 text-center font-bold text-lg">
                ₹ {totalMonthlyCost}
              </td>
            </tr>
          </tfoot>

        </table>
      </div>
    </div>
  </div>
);
};

export default Consumption;
